import React, { useState } from 'react';
import style from '../content-list.module.scss';
import InfiniteScroll from "react-infinite-scroll-component";
import AddIcon from '../../../../../../../../assets/svg/solo-chat/circle-plus.svg';
import { AddPdf } from './AddPdf';
import { Pdf } from './Pdf';
import { Pdf as TPdf } from '../../types';
import { usePermissions } from '../../../../hooks';

type Props = {
	scrollRef:any | null;
	contents: (TPdf & { id: string; updatedAt: string|null; createdAt: string })[];
	hasMore:boolean;
	refetchContent: () => void;
	loadMore: () => void;
};

export function PdfList(props: Props) {
	const { scrollRef, contents: pdfs,hasMore, refetchContent, loadMore} = props;

	return (
		<div className={style.contentList}>
			<Header {...props} />
			<div className={style.selector}>
				<div>
					<p>PDF</p>
				</div>
				<p>Updated At</p>
				<p>Created At</p>
			</div>
			<div  id="infiniteScrollTarget" ref={scrollRef} className={style.textList} style={{overflow: "auto", height: "calc(100vh - 200px)"}}>
				{pdfs.length>0?
					<InfiniteScroll
						dataLength={pdfs.length}
						next={loadMore}
						hasMore={hasMore}
						scrollableTarget="infiniteScrollTarget"
						loader={<div className={style.loadingContainer}>Loading...</div>}
					>
					{pdfs.map((el) => (
						<Pdf key={el.id} pdf={el} refetchContent={refetchContent} />
					))}
					</InfiniteScroll>
				:
					null
				}
			</div>
		</div>
	);
}

function Header(props: Props) {
	const [isOpen, setIsOpen] = useState(false);
	const canCreate = usePermissions('content.Create')
	return (
		<div className={style.header}>
			{ canCreate &&
				<button className={style.add} onClick={() => setIsOpen(true)}>
					<img src={AddIcon} alt="add" />
					<span>Add PDF</span>
				</button>
			}
			{isOpen && (
				<AddPdf
					isOpen={isOpen}
					close={() => setIsOpen(false)}
					refetchContent={props.refetchContent}
				/>
			)}
		</div>
	);
}
